/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PullRequestCollectionBase {
    getFixupPrototypeFunction() { return PullRequestCollectionBase.fixupPrototype; }

    static newInstance(model: Partial<PullRequestCollectionBase>): PullRequestCollectionBase {
        let obj = Object.assign(new PullRequestCollectionBase(), model);
        PullRequestCollectionBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PullRequestCollectionBase>): PullRequestCollectionBase {
        if (!model) return null;
        return PullRequestCollectionBase.newInstance(<PullRequestCollectionBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PullRequestCollectionBase) {
        if (!obj) return;

        models.PullRequestCollectionBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PullRequestCollectionBase): boolean {
        Object.setPrototypeOf(obj, PullRequestCollectionBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (typeof this.merged_at === "string") {
            this.merged_at = new Date(<string><any>this.merged_at);
        }
        if (typeof this.touched_at === "string") {
            this.touched_at = new Date(<string><any>this.touched_at);
        }
        if (this.labels) {
            for (let val of this.labels) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
        if (this.commit_details) {
            for (let val of this.commit_details) {
                models.CommitDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Unique Number which represents the pull request resides with in a repository.
     */
    pull_request_number: string;

    /**
     * A long id which describes the pull request resides with in a repository.
     */
    pull_request_id: string;

    /**
     * Service account which has been onboarded for the organization in github.
     */
    service_account_id: string;

    /**
     * Unique Identifier for the pull request which is auto generated
     */
    sys_id: string;

    /**
     * Status of the auto provisioning job applied for the pull request..
     */
    auto_provisioning_status: models.AutoProvisioningStatus;

    /**
     * Status of the pull request.
     */
    status: models.GithubPullRequestStatus;

    /**
     * A Boolean Field which represents the pull request has been locked for merging or not.
     */
    is_locked: boolean;

    /**
     * The time when the pull request was created.
     */
    created_at: Date;

    /**
     * The time when the pull request was lastly updated.
     */
    updated_at: Date;

    /**
     * The time when the pull request was merged in to the target branch.
     */
    merged_at: Date;

    /**
     * Recently updated datetime of the document.
     */
    touched_at: Date;

    /**
     * The title for the pull request.
     */
    title: string;

    /**
     * List of tag key/value pairs
     */
    labels: Array<models.KeyValuePair>;

    /**
     * A long id which is an unique number for an each repository with in the organization.
     */
    repo_id: string;

    /**
     * A display Name for the repository.
     */
    repo_name: string;

    /**
     * Name of the branch against which the pull request has been raised.
     */
    target_branch: string;

    /**
     * Owner of the pull request.
     */
    owner: string;

    /**
     * status for the repository.
     */
    repo_visibility: models.GithubRepositoryVisibility;

    /**
     * String which contains all the comments available for a pull request including both scanner and other sources.
     */
    overall_comments: Array<string>;

    commit_details: Array<models.CommitDetails>;

}
